export default {
    'searchList': {
        'searchTxt': [
            {
                name: '分公司',
                value: 'companyName',
                unfold: true,
                span: 4,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                    { prop: 'escoCompanyNo', 'value': '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                    { prop: 'escoCompanyNo', 'value': '分公司编码' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
            },
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                span: 4,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
            },
            {
                name: '撤回类型',
                value: 'ettaRecallReasonType',
                unfold: true,
                span: 4,
                type: 'select',
                options: []
            },
            {
                'name': '撤回时间',
                'value': 'createTime',
                'type': 'time',
                'unfold': true,
                'span': 6,
                timeNum: 30,
                'startPlaceholder': '撤回开始时间',
                'endPlaceholder': '撤回结束时间'
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    searchTotalTitle: [
        {
            name: '客户',
            value: 'customerName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebcuNameCn', value: '客户名称' },
                { prop: 'pmCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'pmCode', value: '客户编码' },
                { prop: 'ebcuNameCn', value: '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#ettaCustomEbcuNo', 'ebcuNameCn#customerName']
        },
        {
            name: '运输单号',
            value: 'ettaNo',
            type: 'input'
        },
        {
            name: '客户订单号',
            value: 'ettaSoNo',
            type: 'input'
        }
    ],
    'table':
    {
        'clickState': false,
        'selectBtn': false,
        'height': 400,
        'columns': [
            {
                'label': '分公司',
                'prop': 'companyName',
                width: 160,
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                width: 160,
                'sort': true
            },
            {
                'label': '客户',
                'prop': 'customerName',
                width: 160,
                'sort': true
            },
            {
                'label': '运输单号',
                'prop': 'ettaNo',
                width: 160,
                'sort': true
            },
            {
                'label': '客户订单号',
                'prop': 'ettaSoNo',
                width: 160,
                'sort': true
            },
            {
                'label': '线路',
                'prop': 'ettaEblnLineName',
                width: 160,
                'sort': true
            },
            {
                'label': '撤回类型',
                'prop': 'ettaRecallReasonTypeName',
                width: 160,
                'sort': true
            },
            {
                'label': '撤回原因',
                'prop': 'ettaRecallReason',
                width: 160,
                'sort': true
            },
            {
                'label': '体积',
                'prop': 'volume',
                width: 160,
                'sort': true
            },
            {
                'label': '重量',
                'prop': 'weight',
                width: 160,
                'sort': true
            },
            {
                'label': '发货单位',
                'prop': 'ettaShipperEbspNameCn',
                width: 160,
                'sort': true
            },
            {
                'label': '收货单位',
                'prop': 'ettaConsigneeEbspNameCn',
                width: 160,
                'sort': true
            },
            {
                'label': '始发城市',
                'prop': 'esstFromCityName',
                width: 160,
                'sort': true
            },
            {
                'label': '目的城市',
                'prop': 'esstToCityName',
                width: 160,
                'sort': true
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 110]
    }
};
